import { Toaster } from "react-hot-toast";
import Layout from "../shared/Layout";
import { useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";
import { Link, useParams } from "react-router-dom";
import { API_URL, baseurl } from "../../_config";

const categoryOptions = [
    "Mens Singles",
    "Womens Singles",
    "Mens Doubles",
    "Womens Doubles",
    "Mixed Doubles",
    "Team Event",
];

const statusOptions = ["upcoming", "active", "live", "completed", "cancelled"];

const entityConfig = {
    seasons: {
        title: "YBL Seasons",
        addLabel: "Add Season",
        editLabel: "Edit Season",
        listApi: "getYblSeasons",
        saveApi: "saveYblSeason",
        deleteApi: "deleteYblSeason",
        fields: [
            { name: "tournament_id", label: "Tournament", type: "select", source: "tournaments", optionLabel: "tournamentName", required: true },
            { name: "seasonName", label: "Season Name", required: true },
            { name: "startDate", label: "Start Date", type: "date" },
            { name: "endDate", label: "End Date", type: "date" },
            { name: "status", label: "Status", type: "select", options: statusOptions, defaultValue: "upcoming" },
            { name: "description", label: "Description", type: "textarea", col: 12 },
        ],
        columns: [
            { name: "Tournament ID", selector: "tournament_id" },
            { name: "Tournament", selector: "tournamentName" },
            { name: "Season", selector: "seasonName" },
            { name: "Start Date", selector: "startDate", type: "date" },
            { name: "End Date", selector: "endDate", type: "date" },
            { name: "Status", selector: "status" },
        ],
    },
    teams: {
        title: "YBL Teams",
        addLabel: "Add Team",
        editLabel: "Edit Team",
        listApi: "getYblTeams",
        saveApi: "saveYblTeam",
        deleteApi: "deleteYblTeam",
        fields: [
            { name: "season_id", label: "Season", type: "select", source: "seasons", optionLabel: "seasonName", required: true },
            { name: "teamName", label: "Team Name", required: true },
            { name: "coachName", label: "Coach Name" },
            { name: "contactNumber", label: "Contact Number", type: "tel", maxLength: 10 },
            { name: "emailId", label: "Email ID", type: "email" },
            { name: "city", label: "City" },
            { name: "state", label: "State" },
        ],
        columns: [
            { name: "Tournament", selector: "tournamentName" },
            { name: "Season", selector: "seasonName" },
            { name: "Team", selector: "teamName" },
            { name: "Coach", selector: "coachName" },
            { name: "Contact", selector: "contactNumber" },
            { name: "City", selector: "city" },
            { name: "State", selector: "state" },
        ],
    },
    players: {
        title: "YBL Players",
        addLabel: "Add Player",
        editLabel: "Edit Player",
        listApi: "getYblPlayers",
        saveApi: "saveYblPlayer",
        deleteApi: "deleteYblPlayer",
        fields: [
            { name: "playerName", label: "Player Name", required: true },
            { name: "gender", label: "Gender", type: "select", options: ["Male", "Female", "Other"] },
            { name: "dateOfBirth", label: "Date of Birth", type: "date" },
            { name: "contactNumber", label: "Contact Number", type: "tel", maxLength: 10 },
            { name: "emailId", label: "Email ID", type: "email" },
            { name: "city", label: "City" },
            { name: "state", label: "State" },
            { name: "playingHand", label: "Playing Hand", type: "select", options: ["Right", "Left"] },
            { name: "category", label: "Category", type: "select", options: categoryOptions },
            { name: "ranking", label: "Ranking", type: "number" },
            { name: "team_id", label: "Team", type: "select", source: "teams", optionLabel: "teamName" },
        ],
        columns: [
            { name: "Player", selector: "playerName" },
            { name: "Category", selector: "category" },
            { name: "Team", selector: "teamName" },
            { name: "Hand", selector: "playingHand" },
            { name: "Ranking", selector: "ranking" },
            { name: "Contact", selector: "contactNumber" },
        ],
    },
    tournaments: {
        title: "YBL Tournaments",
        addLabel: "Add Tournament",
        editLabel: "Edit Tournament",
        listApi: "getYblTournaments",
        saveApi: "saveYblTournament",
        deleteApi: "deleteYblTournament",
        fields: [
            { name: "tournamentName", label: "Tournament Name", required: true },
            { name: "location", label: "Location" },
            { name: "startDate", label: "Start Date", type: "date" },
            { name: "endDate", label: "End Date", type: "date" },
            { name: "organizerName", label: "Organizer Name" },
            { name: "contactNumber", label: "Contact Number", type: "tel", maxLength: 10 },
            { name: "emailId", label: "Email ID", type: "email" },
            { name: "category", label: "Category", type: "select", options: categoryOptions },
            { name: "status", label: "Status", type: "select", options: statusOptions, defaultValue: "upcoming" },
            { name: "description", label: "Description", type: "textarea", col: 12 },
        ],
        columns: [
            { name: "Tournament", selector: "tournamentName", type: "tournamentLink" },
            { name: "Category", selector: "category" },
            { name: "Location", selector: "location" },
            { name: "Start Date", selector: "startDate", type: "date" },
            { name: "Status", selector: "status" },
        ],
    },
    matches: {
        title: "YBL Matches",
        addLabel: "Add Match",
        editLabel: "Edit Match",
        listApi: "getYblMatches",
        saveApi: "saveYblMatch",
        deleteApi: "deleteYblMatch",
        fields: [
            { name: "tournament_id", label: "Tournament", type: "select", source: "tournaments", optionLabel: "tournamentName", required: true },
            { name: "season_id", label: "Season", type: "select", source: "seasons", optionLabel: "seasonName", required: true },
            { name: "category", label: "Category", type: "select", options: categoryOptions },
            { name: "participantA_id", label: "Team A", type: "participant", required: true },
            { name: "participantB_id", label: "Team B", type: "participant", required: true },
            { name: "round", label: "Round", type: "select", options: ["League", "Round of 32", "Round of 16", "Quarter Final", "Semi Final", "Final"] },
            { name: "court", label: "Court" },
            { name: "match_date", label: "Match Date", type: "datetime-local" },
            { name: "best_of", label: "Best Of Games", type: "number", defaultValue: 3 },
            { name: "winner_id", label: "Winner Team", type: "participant" },
            { name: "status", label: "Status", type: "select", options: statusOptions, defaultValue: "upcoming" },
            { name: "score_json", label: "Score JSON", type: "textarea", col: 12, placeholder: '[{"a":21,"b":18},{"a":19,"b":21},{"a":21,"b":16}]' },
        ],
        columns: [
            { name: "Tournament", selector: "tournamentName" },
            { name: "A", selector: "participantA_name" },
            { name: "B", selector: "participantB_name" },
            { name: "Round", selector: "round" },
            { name: "Court", selector: "court" },
            { name: "Date", selector: "match_date", type: "datetime" },
            { name: "Winner", selector: "winner_name" },
            { name: "Score", selector: "score_json", type: "score" },
            { name: "Status", selector: "status", type: "matchStatus" },
        ],
    },
};

const dependencyApis = {
    seasons: "getYblSeasons",
    teams: "getYblTeams",
    players: "getYblPlayers",
    tournaments: "getYblTournaments",
};

function formatDate(value, includeTime = false) {
    if (!value) return "-";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;

    const day = date.toISOString().split("T")[0];
    if (!includeTime) return day;

    return `${day} ${date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    })}`;
}

function formatForInput(value, type) {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;

    if (type === "datetime-local") {
        return date.toISOString().slice(0, 16);
    }

    if (type === "date") {
        return date.toISOString().split("T")[0];
    }

    return value;
}

function formatMatchScore(scoreJson) {
    if (!scoreJson) return "-";

    try {
        const games = typeof scoreJson === "string" ? JSON.parse(scoreJson) : scoreJson;
        if (!Array.isArray(games) || !games.length) return "-";

        return games
            .map((game, index) => {
                const teamAScore = game.a ?? game.teamA_score ?? 0;
                const teamBScore = game.b ?? game.teamB_score ?? 0;
                return `R${game.gameNo || index + 1}: ${teamAScore}-${teamBScore}`;
            })
            .join(" | ");
    } catch {
        return "-";
    }
}

function getInitialForm(config, tournamentId) {
    return config.fields.reduce((acc, field) => {
        acc[field.name] = field.name === "tournament_id" && tournamentId
            ? tournamentId
            : field.defaultValue || "";
        return acc;
    }, { id: 0 });
}

const YblLeaguePage = ({ entity }) => {
    const params = useParams();
    const tournamentId = entity === "matches" ? params?.tournamentId : null;
    const config = entityConfig[entity];
    const [rows, setRows] = useState([]);
    const [dependencies, setDependencies] = useState({
        seasons: [],
        teams: [],
        players: [],
        tournaments: [],
    });
    const [loading, setLoading] = useState(false);
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [formData, setFormData] = useState(() => getInitialForm(config, tournamentId));
    const [searchTerm, setSearchTerm] = useState("");

    const pageTitle = useMemo(() => {
        if (!tournamentId || entity !== "matches") return config.title;
        const tournament = dependencies.tournaments.find((item) => Number(item.id) === Number(tournamentId));
        return tournament?.tournamentName ? `${tournament.tournamentName} - Matches` : "YBL Tournament Matches";
    }, [config.title, dependencies.tournaments, entity, tournamentId]);

    const fetchDependencies = useCallback(async () => {
        const result = {};
        await Promise.all(Object.keys(dependencyApis).map(async (key) => {
            try {
                const res = await axios.get(`${baseurl}${API_URL[dependencyApis[key]]}`);
                result[key] = res.data?.data || [];
            } catch {
                result[key] = [];
            }
        }));
        setDependencies((prev) => ({ ...prev, ...result }));
    }, []);

    const fetchRows = useCallback(async () => {
        setLoading(true);
        try {
            const query = tournamentId ? `?tournament_id=${tournamentId}` : "";
            const res = await axios.get(`${baseurl}${API_URL[config.listApi]}${query}`);
            setRows(res.data?.data || []);
        } catch {
            toast.error(`Failed to load ${config.title}`);
        } finally {
            setLoading(false);
        }
    }, [config.listApi, config.title, tournamentId]);

    useEffect(() => {
        fetchDependencies();
    }, [fetchDependencies]);

    useEffect(() => {
        fetchRows();
    }, [fetchRows]);

    const handleClose = () => {
        setIsFormOpen(false);
        setFormData(getInitialForm(config, tournamentId));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const safeValue = name === "contactNumber" ? value.replace(/\D/g, "") : value;

        setFormData((prev) => {
            const next = { ...prev, [name]: safeValue };
            if (name === "tournament_id") {
                next.season_id = "";
                next.participantA_id = "";
                next.participantB_id = "";
                next.winner_id = "";
            }
            if (name === "season_id") {
                next.participantA_id = "";
                next.participantB_id = "";
                next.winner_id = "";
            }
            return next;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (entity === "matches" && formData.score_json) {
            try {
                JSON.parse(formData.score_json);
            } catch {
                toast.error("Score JSON is not valid");
                return;
            }
        }

        if (
            entity === "matches" &&
            formData.participantA_id &&
            formData.participantB_id &&
            Number(formData.participantA_id) === Number(formData.participantB_id)
        ) {
            toast.error("Team A and Team B must be different");
            return;
        }

        try {
            const payload = entity === "matches"
                ? { ...formData, participant_type: "team" }
                : { ...formData };
            const res = await axios.post(`${baseurl}${API_URL[config.saveApi]}`, payload);

            if (res.data?.isSuccess === 1) {
                toast.success(res.data.message || "Saved successfully");
                handleClose();
                fetchRows();
            } else {
                toast.error(res.data?.message || "Save failed");
            }
        } catch {
            toast.error("Error saving data. Please try again.");
        }
    };

    const handleEdit = (item) => {
        const next = getInitialForm(config, tournamentId);
        config.fields.forEach((field) => {
            next[field.name] = formatForInput(item[field.name], field.type);
        });
        next.id = item.id;
        setFormData(next);
        setIsFormOpen(true);
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this record?")) return;

        try {
            const res = await axios.delete(`${baseurl}${API_URL[config.deleteApi]}?id=${id}`);
            if (res.data?.isSuccess === 1) {
                toast.success("Deleted successfully");
                fetchRows();
            } else {
                toast.error(res.data?.message || "Delete failed");
            }
        } catch {
            toast.error("Error deleting data");
        }
    };

    const updateMatchStatus = async (id, status) => {
        try {
            const res = await axios.put(`${baseurl}${API_URL.updateYblMatchStatus}`, { id, status });
            if (res.data?.isSuccess === 1) {
                toast.success("Match status updated");
                fetchRows();
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "Failed to update status");
        }
    };

    const getOptions = (field) => {
        if (field.type === "participant") {
            if (field.name === "winner_id") {
                const selectedTeamIds = [formData.participantA_id, formData.participantB_id]
                    .filter(Boolean)
                    .map((id) => Number(id));
                return dependencies.teams.filter((team) => selectedTeamIds.includes(Number(team.id)));
            }
            return dependencies.teams;
        }

        if (field.source) {
            const options = dependencies[field.source] || [];
            if (field.name === "season_id" && formData.tournament_id) {
                return options.filter((season) => Number(season.tournament_id) === Number(formData.tournament_id));
            }
            return options;
        }

        return field.options || [];
    };

    const getOptionLabel = (field, option) => {
        if (typeof option === "string") return option;
        if (field.type === "participant") {
            return option.teamName;
        }
        if (field.name === "tournament_id") {
            return `${option.id} - ${option.tournamentName || option.name || "Tournament"}`;
        }
        return option[field.optionLabel] || option.name || option.title || option.id;
    };

    const getOptionValue = (option) => {
        if (typeof option === "string") return option;
        return option.id;
    };

    const filteredRows = useMemo(() => {
        if (!searchTerm) return rows;
        const term = searchTerm.toLowerCase();
        return rows.filter((item) => JSON.stringify(item).toLowerCase().includes(term));
    }, [rows, searchTerm]);

    const tableColumns = [
        { name: "S.No", selector: (row, i) => i + 1, width: "70px" },
        ...config.columns.map((column) => ({
            name: column.name,
            sortable: true,
            minWidth: column.type === "datetime" ? "190px" : "150px",
            selector: (row) => {
                if (column.type === "date") return formatDate(row[column.selector]);
                if (column.type === "datetime") return formatDate(row[column.selector], true);
                if (column.type === "tournamentLink") {
                    return <Link to={`/ybl-matches/${row.id}`}>{row[column.selector] || "-"}</Link>;
                }
                if (column.type === "score") return formatMatchScore(row[column.selector]);
                return row[column.selector] || "-";
            },
            cell: column.type === "matchStatus"
                ? (row) => (
                    <select
                        value={row.status || "upcoming"}
                        onChange={(event) => updateMatchStatus(row.id, event.target.value)}
                        className="form-control"
                        style={{ minWidth: "130px" }}
                    >
                        {statusOptions.map((status) => (
                            <option key={status} value={status}>{status}</option>
                        ))}
                    </select>
                )
                : undefined,
        })),
        {
            name: "Action",
            cell: (row) => (
                <div className="d-flex" style={{ gap: "10px" }}>
                    {entity === "matches" && (
                        <Link to={`/ybl-scorecard/${row.id}`} title="Scorecard" className="edit_icon_wepper">
                            <i className="fa fa-table-list" style={{ color: "#9b20ff", cursor: "pointer" }}></i>
                        </Link>
                    )}
                    <span onClick={() => handleEdit(row)} title="Edit" className="edit_icon_wepper">
                        <i className="fa fa-pen" style={{ color: "#ff7722", cursor: "pointer" }}></i>
                    </span>
                    <span onClick={() => handleDelete(row.id)} title="Delete" className="delete_icon_weepr">
                        <i className="fa fa-trash" style={{ color: "#ff0000", cursor: "pointer" }}></i>
                    </span>
                </div>
            ),
            width: entity === "matches" ? "145px" : "110px",
        },
    ];

    return (
        <Layout>
            <Toaster position="top-right" />
            <div className="right-content-section">
                <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading d-flex align-items-center gap-3">
                        {entity === "matches" && tournamentId && (
                            <Link to="/ybl-tournaments" className="back_button">
                                <i className="fas fa-arrow-left"></i>
                            </Link>
                        )}
                        <h4 className="mb-0">{pageTitle}</h4>
                    </div>
                    <div className="d-md-flex align-items-center justify-content-end gap-3">
                        <div className="search-container">
                            <input
                                type="text"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="form-control"
                            />
                        </div>
                        <div className="add_btn">
                            <button onClick={() => setIsFormOpen(true)}>{config.addLabel}</button>
                        </div>
                    </div>
                </div>

                <div className="datatable mt-4">
                    <DataTable
                        columns={tableColumns}
                        data={filteredRows}
                        progressPending={loading}
                        progressComponent={<p>Loading...</p>}
                        pagination
                        highlightOnHover
                    />
                </div>

                <div id="entryformContainer" className={`adminform entryform ${isFormOpen ? "open" : ""}`}>
                    <div className="closebtn">
                        <button onClick={handleClose}>
                            <i className="fa fa-xmark" style={{ color: "#fff", fontSize: "24px" }}></i>
                        </button>
                    </div>

                    <div className="enForm">
                        <div className="text-center form-heading">
                            <h4>{formData.id ? config.editLabel : config.addLabel}</h4>
                        </div>

                        <form onSubmit={handleSubmit}>
                            <div className="row g-3">
                                {config.fields.map((field) => {
                                    const colClass = field.col === 12 ? "col-md-12" : "col-md-6";

                                    if (field.type === "textarea") {
                                        return (
                                            <div className={colClass} key={field.name}>
                                                <label>{field.label}</label>
                                                <textarea
                                                    className="form-control"
                                                    name={field.name}
                                                    rows="3"
                                                    value={formData[field.name] || ""}
                                                    placeholder={field.placeholder || ""}
                                                    onChange={handleChange}
                                                    required={field.required}
                                                />
                                            </div>
                                        );
                                    }

                                    if (field.type === "select" || field.type === "participant") {
                                        return (
                                            <div className={colClass} key={field.name}>
                                                <label>{field.label}</label>
                                                <select
                                                    className="form-control"
                                                    name={field.name}
                                                    value={formData[field.name] || ""}
                                                    onChange={handleChange}
                                                    required={field.required}
                                                >
                                                    <option value="">Select {field.label}</option>
                                                    {getOptions(field).map((option) => (
                                                        <option key={getOptionValue(option)} value={getOptionValue(option)}>
                                                            {getOptionLabel(field, option)}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        );
                                    }

                                    return (
                                        <div className={colClass} key={field.name}>
                                            <label>{field.label}</label>
                                            <input
                                                type={field.type || "text"}
                                                className="form-control"
                                                name={field.name}
                                                value={formData[field.name] || ""}
                                                onChange={handleChange}
                                                required={field.required}
                                                maxLength={field.maxLength}
                                                inputMode={field.type === "tel" ? "numeric" : undefined}
                                            />
                                        </div>
                                    );
                                })}
                            </div>

                            <div className="d-flex form-buttons mt-3" style={{ gap: "15px" }}>
                                <div className="submit-btn pt-2">
                                    <button type="submit">{formData.id ? "Update" : "Submit"}</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default YblLeaguePage;
